// extracted by mini-css-extract-plugin
export default {"title-section":"YJgbON5M17","titleSection":"YJgbON5M17","tabs":"fiR49zpYg2"};